export default __webpack_public_path__ + "static/media/433.934b2e1d.gif";